<template>
  <v-app>
    <v-main>
      <Header />
      <div class="alturacel"></div>
      <router-view :key="$route.fullPath" />
      <FooterPage />
    </v-main>
  </v-app>
</template>

<script>
import Header from './components/PageHeader.vue'
import FooterPage from './components/PageFooter.vue'


export default {
  name: 'App',
  components: {
    Header,
    FooterPage
  },
  data: () => ({

  }),
  methods: {

  },
  created() {

  },
}
</script>

<style>

@import "@/assets/css_cart/carrinho.css";
@import "@/assets/css_cart/calendario.css";
@import "@/assets/css_cart/login.css";
@import "@/assets/css_cart/minha_conta.css";
@import "@/assets/css_cart/nova_conta.css";
@import "@/assets/css_cart/pedido_realizado.css";
@import "@/assets/css_cart/status_conta.css";



@import "@/assets/css/animate.css";
@import "@/assets/css/aos.css";
@import "@/assets/css/avance.css";
@import "@/assets/css/bootstrap.min.css";

@import "@/assets/css/style.css";

@media (max-width:767px) {
  .hidden-xs {
    display: none !important;
  }

  .alturacel {
    margin-top: 0;
  }

}

@media (min-width:768px) and (max-width:991px) {
  .hidden-sm {
    display: none !important;
  }

  .alturacel {
    margin-top: 0px;
  }
}

@media (min-width:992px) and (max-width:1199px) {
  .hidden-md {
    display: none !important;
  }

  .alturacel {
    margin-top: 0px;
  }
}

@media (min-width:1200px) {
  .hidden-lg {
    display: none !important;
  }

  .alturacel {
    margin-top: 0px;
  }
}

.qty {
    position: relative;
    right: -26px;
    top: -39px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 50%;
    font-size: 10px;
    color: #fff;
    background-color: #8f8585;
}
</style>
